import gql from 'graphql-tag';

export const RunGrafanaSlurmDashboardQuery = gql`
  query RunGrafanaDashboardQuery(
    $entityName: String!
    $projectName: String!
    $runName: String!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      run(name: $runName) {
        id
        coreweaveGrafanaDashboard
      }
    }
  }
`;
